import React, { FC } from 'react'
import { observer } from 'mobx-react'
import CategoryBar from '../CategoryBar'
import StoreBar from '../StoreBar'
import EatTypeBar from '../EatTypeBar'
import TimePickBar from '../TimePickBar'
import ServiceRingButton from '../ServiceRingButton'
import './index.scss'

const MenuLeftBar: FC = () => {
  return (
    <div className='menu-style-left-bar-container'>
      <StoreBar />
      <EatTypeBar />
      <TimePickBar />
      <ServiceRingButton />
      <CategoryBar />
    </div>
  )
}

export default observer(MenuLeftBar)
